import React, { useEffect, useState } from 'react';
import { registerUser } from '../../controllers/registerUser';
import { FooterMain } from '../footer/FooterMain';
import { Form, TextInput, Button, Checkbox } from "@wfp/ui";
import { NavLink, useNavigate } from 'react-router-dom';
import { login } from '../../actions/auth';
import { startLoading, finishLoading, setToken } from '../../actions/ui';
import { useDispatch, useSelector } from 'react-redux';
import { PrivacyScreen } from './PrivacyScreen';
import Select from 'react-select';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';
import { ConfigApp } from "../../controllers/ConfigApp";
import { encode as base64_encode } from 'base-64';

// Registration component
export const RegisterScreen = () => {
    const [imgBackType, setImgBackType] = useState(false);
    const [imgBack, setImgBack] = useState('');
    const [imgLogoType, setImgLogoType] = useState(false);
    const [imgLogo, setImgLogo] = useState('');
    const [colorThree, setColorThree] = useState('');
    const [userChoice, setUserChoice] = useState('');
    const [options, setOptions] = useState([]);
    const [showTerms, setShowTerms] = useState(false);
    const [isChecked, setIsChecked] = useState(false); // Estado para el checkbox

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked); // Actualiza el estado cuando cambia el checkbox
    };

    const navigate = useNavigate();
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    const dispatch = useDispatch();
    const { loading } = useSelector( state => state.ui );
    let ran = false;
    useEffect(() => {
        if (ran) return;
        document.getElementById('userName-error-msg').style.display="none";
        document.getElementById('userEmail-error-msg').style.display="none";
        document.getElementById('userPassword-error-msg').style.display="none";
        document.getElementById('userConfPassword-error-msg').style.display="none";
        if(!window.localStorage.getItem('edufami_background')){
            ConfigApp("/appConfig").then((e)=>{
                e.forEach(a => {
                    // eslint-disable-next-line default-case
                    switch (a.name_key) {
                        case "edufami_background" :
                            window.localStorage.setItem('edufami_background', JSON.stringify(a));
                            setImgBackType(a.image_type)
                            setImgBack(a.image_value)
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_logo" :
                            window.localStorage.setItem('edufami_logo', JSON.stringify(a));
                            setImgLogoType(a.image_type)
                            setImgLogo(a.image_value)
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_icon" :
                            window.localStorage.setItem('edufami_icon', JSON.stringify(a));
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_color1" :
                            window.localStorage.setItem('edufami_color1', JSON.stringify(a));
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_color2" :
                            window.localStorage.setItem('edufami_color2', JSON.stringify(a));
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_color3" :
                            window.localStorage.setItem('edufami_color3', JSON.stringify(a));
                            setColorThree(a.text_value)
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_color4" :
                            window.localStorage.setItem('edufami_color4', JSON.stringify(a));
                        break;
                        case "edufami_sponsor1" :
                            window.localStorage.setItem('edufami_sponsor1', JSON.stringify(a));
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_sponsor2" :
                            window.localStorage.setItem('edufami_sponsor2', JSON.stringify(a));
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_sponsor3" :
                            window.localStorage.setItem('edufami_sponsor3', JSON.stringify(a));
                        break;
                        // eslint-disable-next-line no-duplicate-case
                        case "edufami_sponsor4" :
                            window.localStorage.setItem('edufami_sponsor4', JSON.stringify(a));
                        break;
                        case "edufami_feedback_correct" :
                            window.localStorage.setItem('edufami_feedback_correct', JSON.stringify(a));
                        break;
                        case "edufami_feedback_incorrect" :
                            window.localStorage.setItem('edufami_feedback_incorrect', JSON.stringify(a));
                        break;
                        case "edufami_background_courses" :
                            window.localStorage.setItem('edufami_background_courses', JSON.stringify(a));
                        break;
                    }
                })
            })
            .catch((e)=>{
                console.warn(e);
                document.getElementById('invalidMessage').classList.remove('hide');
                
            });
        }
        else{
            setImgBackType(JSON.parse(window.localStorage.getItem('edufami_background')).image_type)
            setImgBack(JSON.parse(window.localStorage.getItem('edufami_background')).image_value)

            setImgLogoType(JSON.parse(window.localStorage.getItem('edufami_logo')).image_type)
            setImgLogo(JSON.parse(window.localStorage.getItem('edufami_logo')).image_value)

            setColorThree(JSON.parse(window.localStorage.getItem('edufami_color3')).text_value)
        }

        ConfigApp("/languages").then((e)=>{
            e.forEach(a => {
                setOptions( oldArray => [...oldArray, { value: a.id, label: a.name }])
                
            })
        })
        .catch((e)=>{
            console.warn(e);
            document.getElementById('invalidMessage').classList.remove('hide');
            
                });
        return () => (ran = true);
    }, [])
    const handleSubmit = (e) => {
        e.preventDefault();
        const btnIngreso = document.getElementById("btnIngresar");
        btnIngreso.classList.remove("btn-wfp-main");
        btnIngreso.classList.add("btn-wfp-main-press");
        const lastPath = '/home';
        let userNameMain = document.getElementById('userName');
        let userName = userNameMain.value;
        let userEmailMain = document.getElementById('userEmail');
        let userEmail = userEmailMain.value;
        let userPasswordMain = document.getElementById('userPassword');
        let userPassword = userPasswordMain.value;
        let userConfPasswordMain = document.getElementById('userConfPassword');
        let userConfPassword = userConfPasswordMain.value;
        if(userName===""){
            userNameMain.classList.add("is-invalid");
            document.getElementById('userName-error-msg').style.display="block";
        }
        else{
            userNameMain.classList.remove("is-invalid");
            document.getElementById('userName-error-msg').style.display="none";
        }
        if(userEmail===""){
            userEmailMain.classList.add("is-invalid");
            document.getElementById('userEmail-error-msg').style.display="block";
        }
        else{
            document.getElementById('userEmail-error-msg').style.display="none";
        }
        
        if(userPassword===""){
            userPasswordMain.classList.add("is-invalid");
            document.getElementById('userPassword-error-msg').style.display="block";
        }
        else{
            document.getElementById('userPassword-error-msg').style.display="none";
        }
        if(userConfPassword===""){
            userConfPasswordMain.classList.add("is-invalid");
            document.getElementById('userConfPassword-error-msg').style.display="block";
        }
        else{
            document.getElementById('userConfPassword-error-msg').style.display="none";
        }
        let invalidMessage = document.getElementById('invalidMessage');
        if(userPassword.length < 6){
            invalidMessage.style.display="block";
            invalidMessage.innerHTML=`${transTxt.registro.top.txt_3} <br/>`;
            alert(`${transTxt.registro.top.txt_3}`)
        }
        if(userPassword === userConfPassword){
            if(userName!=="" && userEmail!=="" && userPassword!=="" && userConfPassword!=="" && userChoice!==""){
                dispatch( startLoading() );
                let dataLog = registerUser(userName,userEmail,userPassword,userConfPassword,userChoice.value);
                dataLog.then((e)=>{
                    // console.log(e)
                    let lang = 'es';
                    if(userChoice.value=='1'){
                        lang = 'es';
                    }
                    else if(userChoice.value=='2'){
                        lang = 'en';
                    }
                    else if(userChoice.value=='3'){
                        lang = 'pr';
                    }
                    else if(userChoice.value=='4'){
                        lang = 'fr';
                    }
                    else if(userChoice.value=='5'){
                        lang = 'cat';
                    }
                    else if(userChoice.value=='6'){
                        lang = 'de';
                    }
                    else{
                        lang = 'ot';
                    }
                    localStorage.setItem('userLanguage',lang)
                    dispatch(login(e.user.id,e.user.email,userChoice.value))
                    dispatch( finishLoading() );
                    dispatch(setToken(e.token));
                    const date = new Date();
                    window.localStorage.setItem('login_token', date);
                    navigate( lastPath, {
                        replace: true
                      });
                })
                .catch((e)=>{
                    console.warn(e);
                    dispatch( finishLoading() );
                });
            }
            invalidMessage.classList.remove("invalid-tooltip-active");
        }
        else{
            invalidMessage.classList.add("invalid-tooltip-active");
        }
    }
    
    return (
        <div className="fund-start">
            {
                imgBackType && (imgBackType==="svg")
                ?
                <img className="fund-start-b-img" src = {`data:image/svg+xml;base64,${base64_encode(imgBack)}`} alt="Back Ground"/>
                :
                <img className="fund-start-b-img" src = {imgBack} alt="Back Ground"/>
            }
            <div className="fund-login-bl-img">
            <NavLink to="/auth" className="wfp--link">{
                imgLogoType && (imgLogoType==="svg")
                ?
                <img className="fund-start-l-img" src = {`data:image/svg+xml;base64,${base64_encode(imgLogo)}`} alt="Back Ground"/>
                :
                <img className="fund-start-l-img" src = {`data:image/${imgLogoType}+xml;base64,${btoa(imgLogo)}`} alt="Back Ground"/>
            }</NavLink>
            </div>
            <div className="text-reg-main">
                <Form onSubmit={ handleSubmit } className="needs-validation">
                    <strong id="invalidMessage" className="invalid-feedback" style={{display: 'none',}}>
                        {transTxt.registro.top.txt_1}
                    </strong>
                    <TextInput
                        placeholder={transTxt.registro.placeholder.imp_1}
                        className="form-control txt-input"
                        name="userEmail"
                        id="userEmail"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.registro.inv_msg.imp_1}
                        required
                    />

                    <TextInput
                        placeholder={transTxt.registro.placeholder.imp_2}
                        className="form-control txt-input"
                        name="userName"
                        id="userName"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.registro.inv_msg.imp_2}
                        required
                    />

                    <TextInput
                        type="password"
                        placeholder={transTxt.registro.placeholder.imp_3}
                        className="form-control txt-input"
                        id="userPassword"
                        name="userPassword"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.registro.inv_msg.imp_3}
                        required
                    />

                    <TextInput
                        type="password"
                        placeholder={transTxt.registro.placeholder.imp_4}
                        className="form-control txt-input"
                        id="userConfPassword"
                        name="userConfPassword"
                        autoComplete="off"
                        invalid={{
                            message: ''
                            }}
                        invalidText={transTxt.registro.inv_msg.imp_4}
                        required
                    />
                    {
                        options && <Select id="slcLang" options={options} 
                        placeholder="Idioma"
                        classNames={{
                            control: (state) =>
                              'border-red-select',
                          }}
                        onChange={(choice) => setUserChoice(choice)}
                        styles={{
                            color: 'red',
                          }}/>
                    }
                    
                    <br />
                    <Checkbox 
                    defaultChecked={isChecked} 
                    className='terms-privacy-ch' 
                    id="chkPriva" 
                    onChange={handleCheckboxChange}
                    />
                    <span
                        className='terms-privacy'
                        onClick={() => setShowTerms(true)} // Show popup on click
                    >
                        Nota de privacidad
                    </span>
                    {/* Popup for showing terms */}
                    {showTerms && (
                        <PrivacyScreen showTerms={showTerms} setShowTerms={setShowTerms} />
                    )}
                    <br />
                    <br />
                    <Button
                        id="btnIngresar"
                        type="submit"
                        className="btn m-1 btn-block btn-outline-primary btn-wfp-main btn-wfp-main-reg"
                        disabled={loading || !isChecked}
                        style={{
                            backgroundColor: colorThree,
                            borderColor: colorThree,
                        }}
                    >
                        {transTxt.btn.reg.txt}
                    </Button>
                </Form>
            </div>

            <FooterMain />

        </div>
    )
}
